import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const VaOnboardingSpotlight = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "va-reporting-onboarding" */ './va-reporting-onboarding')),
    LoadingSkeleton: () => null,
});
